import { HTTPError } from "ky";

export async function getKyErrorDetails(error: unknown): Promise<string | null> {
    if (!(error instanceof HTTPError) || !error.response) {
        return null;
    }

    try {
        const res = error.response;
        const body = res.headers.get("content-type")?.includes("application/json") ? await res.json() : await res.text();

        return JSON.stringify(
            {
                status: res.status,
                statusText: res.statusText,
                url: res.url,
                body,
            },
            null,
            2,
        );
    } catch {
        return "Cannot parse error response";
    }
}
